export default __webpack_public_path__ + "static/media/login__logo.a50057ca.png";